import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, OnInit, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { getSliderEntities, LoadSlider } from '../store';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { LoadingIndicatorComponent } from 'src/app/standalone/components/loading-indicator/loading-indicator.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ContentSliderDialogComponent } from 'src/app/standalone/dialogs/content-slider-dialog/content-slider-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { StripHtmlPipe } from '@teamfoster/sdk/text-utility';
import { EmblaSliderComponent } from '@teamfoster/embla-slider';

@Component({
  selector: 'app-content-slider',
  imports: [LoadingIndicatorComponent, FromDictionaryPipe, IconComponent, StripHtmlPipe, NgClass, NgOptimizedImage, EmblaSliderComponent],
  templateUrl: './content-slider.component.html',
  styleUrl: './content-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentSliderComponent implements OnInit {
  // Inputs with dynamic hook dont work with signals yet
  readonly id = input.required<number>();
  #dialog = inject(MatDialog);
  #store = inject(Store);

  loadedSliders$ = this.#store.selectSignal(getSliderEntities);
  slider$ = computed(() => {
    const id = this.id();
    return this.loadedSliders$()?.[id];
  });
  loading$ = computed(() => !this.slider$());
  hasDialog = computed(() => this.slider$()?.galleryType === 'type--advanced' || !this.slider$()?.galleryType);

  ngOnInit(): void {
    const id = this.id();
    this.#store.dispatch(LoadSlider({ id }));
  }

  preventBack(event: any) {
    if (event.wheelDeltaX !== 0) {
      event.preventDefault();
    }
  }

  openModal(index: number): void {
    if (!this.hasDialog()) {
      return;
    }

    this.#dialog.open(ContentSliderDialogComponent, {
      data: { activeIndex: index, slides: this.slider$()?.slides },
      width: '100%',
      maxWidth: 'min(calc(100vw - 50px), 1000px)',
      maxHeight: 'calc(100dvh - 50px)',
      height: '100%',
      minHeight: '400px',
      panelClass: 'custom-background-and-scroll',
    });
  }
}
